import { MutableRefObject, useCallback } from 'react';
import { LiveDraft } from '@utils/editors/live-transcript-state.ts';

type Props = {
  draftKey: string;
  generation: MutableRefObject<number>;
  discarded: MutableRefObject<boolean>;
  rows: MutableRefObject<LiveDraft[]>;
  saving: MutableRefObject<number | null>;
  cancelSpeakerAutosave: () => void;
};

export const useLiveTranscriptDiscard = ({
  draftKey,
  generation,
  discarded,
  rows,
  saving,
  cancelSpeakerAutosave
}: Props) =>
  useCallback(() => {
    if (saving.current !== null) return false;
    localStorage.removeItem(draftKey);
    cancelSpeakerAutosave();
    generation.current += 1;
    discarded.current = true;
    rows.current = [];
    return true;
  }, [cancelSpeakerAutosave, discarded, draftKey, generation, rows, saving]);
